module.exports = __webpack_public_path__ + "static/media/zoleWon_250_500.4cc8e194.png";